<template>
  <hr class="hidden lg:block lg:my-2">
</template>

<script>
export default {
  name: 'NavBarMenuDivider'
}
</script>
